import { useEffect, useState } from 'react';
import { authAPI } from '../services/api';

/**
 * Whether Google sign-in is enabled and configured on the server (public check).
 * `null` while loading — hide the Google button until resolved to avoid a flash.
 */
export function useGoogleSignInEnabled(): boolean | null {
  const [enabled, setEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;

    authAPI
      .getGoogleSignInStatus()
      .then((res) => {
        if (cancelled) return;
        setEnabled(Boolean(res.data?.success && res.data?.data?.enabled));
      })
      .catch(() => {
        if (!cancelled) setEnabled(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return enabled;
}
